import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketSelectSectionTemplate from './BasketSelectSectionTemplate';
import { rem } from 'polished';

export const BasketSelectSectionStyled = styled(BasketSelectSectionTemplate)`
    .sections {
        margin: ${rem(16)} 0 0 0;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            justify-content: space-between;
        }

        .left {
            margin: ${rem(13)} 0;

            @media (min-width: ${breakpoints.md}px) {
                margin: 0 ${rem(8)} 0 0;
            }
        }

        .right {
            margin: ${rem(13)} 0;

            @media (min-width: ${breakpoints.md}px) {
                margin: 0 0 0 ${rem(8)};
            }
        }

        .left,
        .right {
            cursor: pointer;
            width: 100%;
            border: 1px solid ${({ theme }) => theme.colors.grey25};
            height: auto;
            background: none;
            display: flex;
            flex-direction: column;
            text-align: left;
            padding: 0;

            &:hover,
            &:focus-visible,
            &.selected {
                border: 1px solid ${({ theme }) => theme.colors.primary};
                background: ${({ theme }) => theme.colors.primaryLight};
                .inner {
                    border: 1px solid ${({ theme }) => theme.colors.primary};
                }
            }

            .inner {
                width: 100%;
                height: 100%;
                padding: ${rem(16)} ${rem(8)} 0 ${rem(60)};
                border: 1px solid transparent;
            }

            @media (min-width: ${breakpoints.xs}px) {
                height: auto;
                min-height: ${rem(109)};

                .inner {
                    padding: ${rem(26)} ${rem(8)} 0 ${rem(64)};
                }
            }

            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }

            .title {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                display: block;
                padding-bottom: ${rem(3)};
                position: relative;
                line-height: ${rem(20)};

                .icon {
                    border: 1px solid #73767a;
                    width: ${rem(24)};
                    height: ${rem(24)};
                    position: absolute;
                    left: -${rem(40)};
                    top: -${rem(2)};
                    border-radius: 50%;

                    .selected {
                        background: ${({ theme }) => theme.colors.primary};
                        width: ${rem(12)};
                        height: ${rem(12)};
                        position: absolute;
                        top: ${rem(5)};
                        left: ${rem(5)};
                        border-radius: 50%;
                    }
                }
            }

            .description {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
                color: ${({ theme }) => theme.colors.grey27};
            }

            .label,
            .shortDescription,
            .price {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }

            .label {
                margin-bottom: ${rem(4)};
                color: #FF9D00;
            }

            .price {
                margin-top: ${rem(12)};
            }

            .detail {
                display: flex;
                margin-top: ${rem(20)};
                padding-bottom: ${rem(20)};

                img {
                    width: 40%;
                    padding: ${rem(10)};
                    margin-right: ${rem(10)};
                }

                &_rows {
                    display: flex;
                    flex-direction: column;
                    gap: ${rem(5)};
                }
            }
        }
    }
`;
